export default __webpack_public_path__ + "static/media/regulatory--snowmobiles-only--g1.1dde78d9.png";